export default __webpack_public_path__ + "static/media/diamond_flare.b3c3e12d.png";